
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {ActionDefinition, Duty, ListItem, MqttAction} from '../../backend/backendapi';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import DutyStore from '../../../stores/DutyStore';
import UserStore from "../../../stores/UserStore";

@Component({
  components: {
    vSelect,
  },
})
export default class DefinitionEditorMqttFromVisitorManagementSpecific extends Vue {
  @Prop({ required: true })
  definition!: ActionDefinition;
  @Prop({ required: true })
  parsedJsonParameters!: any;

  readonly dutyStore = new DutyStore();
  readonly userStore = new UserStore();

  public canSaveChanged() {
    this.$nextTick(() => {
      let res = (this.dutyId !== null) && (this.mqttAction !== null);
      this.$emit("canSaveChanged", res);
    });
  }

  get duties(): Duty[] {
    const ret = [...this.dutyStore.duties];
    ret.sort((l, r) => l.title.localeCompare(r.title));
    return ret;
  }

  get dutyId(): number | null {
    return this.parsedJsonParameters.dutyId ?? null;
  }

  set dutyId(value: number | null) {
    this.parsedJsonParameters.dutyId = value;
    this.onParsedJsonChanged();
    this.canSaveChanged();
  }
  
  get userId(): string | null {
    return this.parsedJsonParameters.userId ?? null;
  }

  set userId(value: string | null) {
    this.parsedJsonParameters.userId = value;
    this.onParsedJsonChanged();
    this.canSaveChanged();
  }


  get mqttAction(): MqttAction | null {
    return this.parsedJsonParameters.action ?? null;
  }

  set mqttAction(value: MqttAction | null) {
    this.parsedJsonParameters.action = value;
    this.onParsedJsonChanged();
  }

  get mqttActionOptions(): Array<{ label: string; value: MqttAction }> {
    return Object.keys(MqttAction)
        .filter(k => isNaN(Number(k))) // keep only enum names, skip reverse numeric keys
        .map(k => ({
          label: k,
          value: MqttAction[k as keyof typeof MqttAction] as MqttAction,
        }));
  }
  
  async mounted(): Promise<void> {
    await this.dutyStore.loadIfAbsent();
    await this.userStore.loadIfAbsent();

    this.canSaveChanged();
  }

  onParsedJsonChanged() {
    this.$emit('changed', this.parsedJsonParameters);
    this.canSaveChanged();
  }
  
}
